import Cookies from 'js-cookie'

/**
 * Check if we're in production environment
 * Production is determined by checking if Stripe publishable keys contain 'pk_live'
 */
const isProduction = () => {
  const config = require('../config');
  // Check if either region is using live keys
  return config.stripe_publishable_key_rgn5?.includes('pk_live') || 
         config.stripe_publishable_key_rgn3?.includes('pk_live');
};

/**
 * Conditional logger - only logs in local and staging (not production)
 */
export const devLog = (...args) => {
  if (!isProduction()) {
    console.log(...args);
  }
};

/**
 * Check if a region is configured to collect payments
 * @param {string} regionId - The region ID (e.g., 'rgn_5', 'rgn_3')
 * @returns {boolean} - True if the region collects payments, false for pledge-only
 */
export const isPaymentRegion = (regionId) => {
  const config = require('../config');
  return config.region_payment_enabled[regionId] === true;
};

/**
 * Format Org and Username correctly for the Serverless Platform backend
 */
export const formatOrgAndUsername = (name = '') => {
  name = name.toString().toLowerCase().replace(/[^a-z\d-]+/gi, '-')
  // Remove multiple instances of hyphens
  name = name.replace(/-{2,}/g, '-')
  if (name.length > 40) {
    name = name.substring(0, 40)
  }
  return name
}

/**
 * Parse query parameters in a URL
 * @param {*} searchString
 */
export const parseQueryParams = (searchString = null) => {
  if (!searchString) {
    return null
  }

  // Clone string
  let clonedParams = (' ' + searchString).slice(1)

  return clonedParams
    .substr(1)
    .split('&')
    .filter((el) => el.length)
    .map((el) => el.split('='))
    .reduce(
      (accumulator, currentValue) =>
        Object.assign(accumulator, {
          [decodeURIComponent(currentValue.shift())]: decodeURIComponent(currentValue.pop())
        }),
      {}
    )
}

/**
 * Parse hash fragment parameters in a URL
 */
export const parseHashFragment = (hashString) => {
  const hashData = {}
  let hash = decodeURI(hashString)
  hash = hash.split('&')
  hash.forEach((val) => {
    val = val.replace('#', '')
    hashData[val.split('=')[0]] = val.split('=')[1]
  })
  return hashData
}

/**
 * Save session in browser cookie
 */
export const saveSession = (userId, userEmail, userToken) => {
  const session = { userId, userEmail, userToken };
  devLog("Saving session");
  Cookies.set('reciprocity', JSON.stringify(session), { secure: true, sameSite: 'strict' });
  devLog("Saved");
  return session;
}

/**
 * Get session in browser cookie
 */
export const getSession = () => {
  const data = Cookies.get('reciprocity');
  if (!data) return null;
  let parsedData = null;
  try {
    parsedData = JSON.parse(data);
  } catch (e) {
    devLog(e);
    return null;
  }
  return parsedData;
}

/**
 * Delete session in browser cookie
 */
export const deleteSession = () => {
  Cookies.remove('reciprocity');
}
